<template>
  <div>
    <div
      v-if="editableStyleId !== styleItem.id"
      class="style-item"
      :class="className"
      :style="{ ...styles }"
      @click="selectStyle"
      @contextmenu="rightClick"
    >
      {{ truncatedStyleName }}
    </div>
    <input
      v-if="editableStyleId === styleItem.id"
      ref="editableStyle"
      :style="{ ...styles }"
      :value="styleItem.name"
      class="style-item style-item-input"
      @change="saveText"
    />
    <style-context-menu
      v-if="activeContextMenu.id === styleItem.id"
      :style-item="styleItem"
      :data-test-id="`style-context-menu-${styleItem.name}`"
    />
    <edit-toolbox
      v-if="editableStyleId === styleItem.id"
      :style-index="index"
      :data-test-id="`edit-toolbox-${styleItem.name}`"
    />
  </div>
</template>

<script>
import StyleContextMenu from "./StyleContextMenu.vue";
import EditToolbox from "../../body/edit-context-menu/EditToolbox.vue";
import DesignerMixin from "../../DesignerMixin";
export default {
  components: {
    StyleContextMenu,
    EditToolbox,
  },
  mixins: [DesignerMixin],
  props: ["index", "styleItem", "className"],
  computed: {
    styles() {
      return {
        fontFamily: this.styleItem.fontFamily,
        fontSize: "14px",
        fontWeight: this.styleItem.fontWeight,
        backgroundColor: this.styleItem.bgColor,
        color: this.styleItem.color,
        textAlign: this.styleItem.textAlign,
      };
    },
    editableStyleId() {
      return this.$store.state.preferences.editableStyleId;
    },
    activeContextMenu() {
      return this.$store.state.activeContextMenu;
    },
    truncatedStyleName() {
      if (this.styleItem.name.length > 4) {
        return this.styleItem.name.substring(0, 2) + "..";
      } else {
        return this.styleItem.name;
      }
    },
  },
  methods: {
    selectStyle() {
      this.$store.dispatch("rangeStyle/updateRangeStyle", { data: this.styleItem });
      this.$store.dispatch("preferences/toggleShowCutomStyles", false);
    },
    rightClick(e) {
      e.preventDefault();
      this.$store.dispatch("setActiveContextMenu", { id: this.styleItem.id, x: e.x, y: e.y });
    },
    saveText(e) {
      this.$store.dispatch("preferences/updateStyle", { index: this.index, data: { name: e.target.value } });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../../assets/styles/variables.less";
.style-item {
  height: 1.7rem;
  width: 2rem;
  background-color: white;
  border-radius: @kk-border-radius;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  &:hover,
  &-active {
    border: 1px solid @kk-color-gray;
  }
  &-input {
    border: 1px solid red;
    cursor: auto;
    &:hover {
      border: 1px solid red;
    }
  }
}
</style>
